import { useEffect, useState } from 'react';
import SignupPage from './SignupPage';
import PortalPage from './PortalPage';
import LoginEmailPage from './LoginEmailPage';
import LoginCodePage from './LoginCodePage';

// Tiny hash router — surfaces:
//   #/signup            → public referrer sign-up (default)
//   #/login             → passwordless login: enter email
//   #/login/code        → passwordless login: enter 6-digit code
//   #/portal/<token>    → passwordless referrer portal
function parseHash() {
  const hash = (window.location.hash || '').replace(/^#/, '');
  const portal = hash.match(/^\/portal\/(.+)$/);
  if (portal) return { route: 'portal', token: decodeURIComponent(portal[1]) };
  if (hash === '/login/code') return { route: 'login-code' };
  if (hash === '/login') return { route: 'login' };
  return { route: 'signup' };
}

export default function App() {
  const [loc, setLoc] = useState(parseHash());
  useEffect(() => {
    const onHash = () => setLoc(parseHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (loc.route === 'portal') return <PortalPage token={loc.token} />;
  if (loc.route === 'login') return <LoginEmailPage />;
  if (loc.route === 'login-code') return <LoginCodePage />;
  return <SignupPage />;
}
